import { render } from "./DynamicForm.vue?vue&type=template&id=6811af3e&scoped=true"
import script from "./DynamicForm.vue?vue&type=script&lang=js"
export * from "./DynamicForm.vue?vue&type=script&lang=js"

import "./DynamicForm.vue?vue&type=style&index=0&id=6811af3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6811af3e"]])

export default __exports__